import axios from "axios";

let alreadyRedirected = false; // Module-level flag

const instance = axios.create({
  //  baseURL: "http://127.0.0.1:8000/api/",  //--------- Local ip url
//  baseURL: "https://swtprime.com/seriti/backend/public/api/",  //--------- Prime login url
  // baseURL: "http://api.swttest.in/api/",
  baseURL: "https://api.bwmyseriti.com/api/",  //--------- main live url
  headers: {
    'accept': 'application/json',
    'Access-Control-Allow-Origin': "*",
    //'content-type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Credentials': 'true',
    
    Authorization: {
      toString() {
        return `Bearer ${localStorage.getItem("Token") ? JSON.parse(localStorage.getItem("Token")).token : ""}`;
      },
    },
  },
});

//----------- New added for Token Expired
// Add token to every request
instance.interceptors.request.use(
  (config) => {
    const authToken = localStorage.getItem("token");
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response handler
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      if (!alreadyRedirected) {
        alreadyRedirected = true;
        // Optional: reset the lock after a short delay to allow new login
        setTimeout(() => {
          alreadyRedirected = false;
        }, 3000); // 5 seconds lock

        alert("Login expired! Please login again.");
        localStorage.clear();
        window.location.href = "/signin";
      }
    }

    if (error.response && error.response.status === 500) {
      //console.log(error.response.data);
      let lastLoggedErrorTime = 0;
      const ERROR_LOG_THROTTLE_MS = 5000; 

      const now = Date.now();
      if (now - lastLoggedErrorTime > ERROR_LOG_THROTTLE_MS) {
        lastLoggedErrorTime = now;
       
        const payload = {
          transaction_no: localStorage.getItem("transaction_id") || 0,
          file_name: error.response.data?.file || "Unknown",
          line_no: error.response.data?.line || "N/A",
          error_message: error.response.data?.message || "No message",
          exception: error.response.data?.exception || "No exception",
          endpoint: error.config?.url || "Unknown endpoint", // Add endpoint for context
        };
    
        instance.post("add_system_error", payload)
          .then((res) => {
            // console.log("Logged system error:", res);
          })
          .catch(() => {
            console.log("Failed to log system error");
          });
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
